<div class="list-filter-single d-flex align-content-center">
  <div class="form-control-checkbox">
    <label class="m-0 d-flex align-items-center">
      <input type="checkbox" [formControl]="form.get(controlName)" />
      <span></span>
      <span [innerHTML]="name"></span>
    </label>
  </div>
</div>
